export default __webpack_public_path__ + "static/media/syringe.691fb062.svg";